(function () {
  if (window.__byldCartInit) return;
  window.__byldCartInit = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  async function notifyTheme(cart, variantId, sections) {
    try {
      var mod = await import(window.byldEventsUrl);
      document.dispatchEvent(new mod.CartAddEvent(cart, 'byld-add-to-cart', { source: 'byld-add-to-cart', itemCount: cart.item_count, variantId: String(variantId), sections: sections || {} }));
      return true;
    } catch (e) { return false; }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-byld-qty]');
    if (!b) return;
    e.preventDefault();
    var input = b.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.getAttribute('data-byld-qty')));
  });
  document.addEventListener('submit', async function (e) {
    var form = e.target.closest('form[data-byld-atc], form.byld-pf');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var label = btn && btn.querySelector('.byld-btn__label');
    var original = label ? label.textContent : '';
    var err = form.querySelector('.byld-atc-error');
    if (err) err.hidden = true;
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    var id = form.querySelector('[name="id"]').value;
    var q = form.querySelector('[name="quantity"]');
    var quantity = q ? Math.max(1, parseInt(q.value, 10) || 1) : 1;
    var sectionIds = Array.prototype.map.call(document.querySelectorAll('cart-items-component[data-section-id]'), function (el) { return el.dataset.sectionId; });
    try {
      var body = { items: [{ id: Number(id), quantity: quantity }] };
      if (sectionIds.length) { body.sections = sectionIds.join(','); body.sections_url = window.location.pathname; }
      var res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
      var data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      var cart = await (await fetch(root + 'cart.js')).json();
      var ok = await notifyTheme(cart, id, data.sections);
      if (!ok) { window.location.href = root + 'cart'; return; }
      if (label) { label.textContent = 'Added ✓'; setTimeout(function () { label.textContent = original; }, 2000); }
    } catch (error) {
      if (err) { err.textContent = error.message; err.hidden = false; }
    } finally {
      if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
    }
  });
})();